import React from 'react';
import {Button} from 'antd';
import styled from 'styled-components';

const StyledButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 38px;
`;

export default function WidgetButton(props) {
  return <StyledButton type="primary" style={{}} {...props} />;
}
